import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { makeStyles } from "@material-ui/core/styles";
import { DownloadIcon, PrintIcon } from "@egovernments/digit-ui-react-components";
import ReactToPrint from "react-to-print";
import { FaFileExcel } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { convertEpochToDate } from "@egovernments/digit-ui-module-pt/src/utils";
import SummaryDetail from "./summaryDetail";
import useModuleSummary, { prepareDashboardData, STATUS_LABELS } from "./useModuleSummary";

const useStyles = makeStyles((theme) => ({
  customTab: {
    backgroundColor: "#1F4A7C",
    color: "white",
    marginRight: "3px",
    borderRadius: "3px",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      color: "black",
      border: `1px solid ${theme.palette.primary.main}`,
    },
    printerTab: {
      backgroundColor: "#1F4A7C",
      color: "white",
      marginLeft: "200px",
      borderRadius: "2px",
    },
    printerIcon: {
      verticalAlign: "middle",
      marginLeft: "5px",
    },
  },
}));

function SummaryReport() {
  const classes = useStyles();
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const [value, setValue] = React.useState("1");
  const componentPDF = React.useRef();
  const [apiData, setApiData] = useState(null);
  const { t } = useTranslation();
  const moduleSummary = useModuleSummary(apiData);
  const [newAPiData, setNewAPiData] = useState(null);
  const [selectedModule, setSelectedModule] = useState("");

  React.useEffect(() => {
    if (apiData?.MisData) {
      const newPreparedData = prepareDashboardData(apiData?.MisData, selectedModule);

      setNewAPiData(newPreparedData);
    }
  }, [apiData?.MisData, selectedModule]);

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  // const handleExcelDownload = () => {
  //   if (!moduleSummary?.length) return;

  //   const excelData = moduleSummary?.map((item) => ({
  //     module_name: t(item.moduleName) || "N/A",
  //     total_files: item.total,
  //     draft_files: item.draft,
  //     approved_files: item.approved,
  //   }));

  //   return Digit.Download.Excel(excelData, "module-wise-application-summary");
  // };

  const handleExcelDownload = () => {
    if (!newAPiData?.tableData?.length) return;

    const { tableData, statuses } = newAPiData;

    const excelData = tableData.map((row, index) => {
      const excelRow = {
        "Sl. No": index + 1,
        "Development Authority": row.developmentAuthorityName,
      };

      // Add all dynamic status columns
      statuses.forEach((status) => {
        excelRow[STATUS_LABELS[status] || status] = row[status] || 0;
      });

      // Grand Total
      excelRow["Grand Total"] = row.grandTotal;

      return excelRow;
    });

    Digit.Download.Excel(excelData, "Map-Submission-High-Risk-Status");
  };
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", marginLeft: "20px" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" defaultIndex={selectedTabIndex}>
            <Tab label="Summary Reports" value="1" className={classes.customTab} />
            <ReactToPrint
              trigger={() => (
                <button style={{ marginLeft: "45rem" }} id="invoice-print">
                  <PrintIcon />
                </button>
              )}
              content={() => componentPDF.current}
            />
            <button className="mrlg cursorPointer" onClick={handleExcelDownload} style={{ marginLeft: "3rem" }}>
              <FaFileExcel style={{ fontSize: "22px" }} />
            </button>
          </TabList>
        </Box>
        <div ref={componentPDF}>
          <TabPanel value="1">
            <SummaryDetail
              setApiData={setApiData}
              apiData={apiData}
              newApiData={newAPiData}
              selectedModule={selectedModule}
              setSelectedModule={setSelectedModule}
            />
          </TabPanel>
        </div>
      </TabContext>
    </Box>
  );
}

export default SummaryReport;
